var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendorPortalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127,
    height: 103,
    viewBox: "0 0 127 103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20700",
    "data-name": "Group 20700",
    transform: "translate(-1380 -361)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6499",
    "data-name": "Rectangle 6499",
    width: 127,
    height: 103,
    rx: 10,
    transform: "translate(1380 361)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21195",
    "data-name": "Path 21195",
    d: "M33.2,54.766l.7.89c.107.136.221.263.329.4s.188.228.284.341c.243.29.488.576.74.855l.027.029A28.715,28.715,0,0,0,49.309,65.8l.254.067q.537.135,1.077.254c.163.034.328.067.492.1.31.06.622.117.935.167.229.037.462.067.692.1.266.036.532.073.8.1.307.033.616.055.925.078.2.015.407.037.612.047.522.028,1.047.045,1.576.045s1.052-.017,1.574-.045c.21-.011.419-.032.627-.047.3-.023.606-.046.906-.078.277-.029.551-.067.827-.106.219-.029.438-.059.655-.093.328-.052.655-.113.981-.176.144-.028.287-.056.431-.087.382-.081.763-.169,1.145-.266l.165-.042A28.775,28.775,0,0,0,79.449,55.668l.7-.89-.031-.038a28.938,28.938,0,1,0-46.911.01Zm28.749,8.542c-.032.008-.065.013-.1.019q-1.219.246-2.477.382l-.142.011c-.842.083-1.694.127-2.557.127s-1.713-.047-2.554-.127l-.149-.011a24.593,24.593,0,0,1-2.461-.382l-.121-.023a26.052,26.052,0,0,1-14.456-8.56,26.034,26.034,0,0,1,39.476,0,26.02,26.02,0,0,1-14.456,8.567ZM56.672,11.789A26.016,26.016,0,0,1,78.219,52.4a28.924,28.924,0,0,0-43.089,0A26.013,26.013,0,0,1,56.678,11.789Zm0,27.584a10.956,10.956,0,1,1,.006,0Zm0-18.983a8.058,8.058,0,1,0,.006,0Z",
    transform: "translate(1387.338 374.816)",
    fill: "#262626",
    stroke: "#262626",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorPortalIcon);
export default __webpack_public_path__ + "static/media/vendor_portal_icon.f5980635c4979043b6e93d8ecacd68f3.svg";
export { ForwardRef as ReactComponent };